"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Return positions advance width
 *
 * @param  {Object}  positions
 * @return {number} advance width
 */

var advanceWidth = function advanceWidth(positions) {
  return positions.reduce(function (acc, pos) {
    return acc + (pos.xAdvance || 0);
  }, 0);
};

var _default = advanceWidth;
exports["default"] = _default;